import { render } from "./NavMenu.vue?vue&type=template&id=5ceeff69"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"
script.render = render

export default script